import { Address } from "types";

export const areAddressesDifferent = (address1: Address, address2: Address) =>
  address1.street_address !== address2.street_address || address1.city !== address2.city;
